import React from 'react';
import Divider from '@ajat/design-system/Divider';
import ColorSwatch from '@ajat/design-system/ColorSwatch';
import { ComponentPage, DemoCard, DemoRow, Demo } from '../../shared';

export const meta = {
  title: 'Divider & Swatch',
  group: 'Data display',
  importPath: '@ajat/design-system/Divider',
  description:
    'Two small primitives. Divider: a hairline, or a word between two hairlines ("eller" between sign-in methods). ColorSwatch: the ringed colour dot beside a colour name.',
  propSets: [
    {
      title: 'Divider',
      component: Divider,
      componentName: 'Divider',
      rows: [
        ['label', 'string', '—', 'Word between the two hairlines'],
        ['className', 'string', "''", 'Additional CSS class'],
      ],
    },
    {
      title: 'ColorSwatch',
      component: ColorSwatch,
      componentName: 'ColorSwatch',
      rows: [
        ['color', 'string', '—', 'CSS colour — hex, rgb or a token'],
        ['label', 'string', '—', 'Colour name for assistive tech; without it the dot is decorative'],
        ['size', "'s' | 'm' | 'l'", "'m'", '8 / 12 / 16px'],
        ['className', 'string', "''", 'Additional CSS class'],
      ],
    },
  ],
  usage: [
    {
      title: 'Between sign-in methods',
      code: `import Divider from '@ajat/design-system/Divider';
import ColorSwatch from '@ajat/design-system/ColorSwatch';

<Divider label="eller" />
<ColorSwatch color="#b3121b" label="Röd" /> Röd · M`,
    },
  ],
};

export default function DividerPage() {
  return (
    <ComponentPage meta={meta}>
      <DemoCard title="Divider">
        <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-ui-medium-l)', maxWidth: 420 }}>
          <Divider />
          <Divider label="eller" />
        </div>
      </DemoCard>
      <DemoCard title="ColorSwatch">
        <DemoRow align="center">
          <Demo caption="S"><ColorSwatch color="#b3121b" size="s" /></Demo>
          <Demo caption="M"><ColorSwatch color="#2e4a7d" /></Demo>
          <Demo caption="L · WHITE"><ColorSwatch color="#fff" size="l" label="Vit" /></Demo>
        </DemoRow>
      </DemoCard>
    </ComponentPage>
  );
}
